export function sadaqahFundingFor(invoice) {
  if (!invoice) return null
  if (invoice.SadaqahInvoiceFunding) return invoice.SadaqahInvoiceFunding
  const permanent = invoice.SadaqahInvoiceFundings || []
  if (!permanent.length) return null
  const latest = permanent.slice().sort((left, right) => new Date(right.fundedAt) - new Date(left.fundedAt))[0]
  return { ...latest, amount: permanent.reduce((sum, funding) => sum + Number(funding.amount || 0), 0), fundingType: 'PERMANENT' }
}

export function sadaqahFundingTooltip(invoice, moment) {
  const funding = sadaqahFundingFor(invoice)
  if (!funding) return ''
  const amount = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(Number(funding.amount || 0))
  const category = funding.DonationCategory && funding.DonationCategory.name ? funding.DonationCategory.name : 'Sadaqah'
  const user = funding.FundedByUser && funding.FundedByUser.name ? funding.FundedByUser.name : 'an administrator'
  const date = funding.fundedAt && moment ? moment(funding.fundedAt).format('MMMM D, YYYY [at] h:mm A') : 'an earlier date'
  if (funding.fundingType === 'PERMANENT') return `${amount} was permanently funded from ${category} on ${date} by ${user}. This assistance cleared the parent balance and is not expected back.`
  return `${amount} was funded temporarily from ${category} on ${date} by ${user}. The parent balance remains due. Any parent payment received must be returned from tuition to this fund.`
}
